import lt81 from "./44.webp";
import lt82 from "./t8.webp";

const lt8 = [lt82, lt81];

export default lt8;
